import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from 'contexts/AuthContext';
import DadosProvider from 'contexts/DadoProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <DadosProvider>
      <App />
    </DadosProvider>
  </AuthProvider>
  // </React.StrictMode>
);

